<script>
export default {
  name: 'PageCard',
  props: {
    page: Object,
    selected: Boolean
  }
};
</script>

<template>
  <div :class="{'page-card': true, selected}" @click="$emit('click', $event)">
    <router-link
      :to="{
        name: 'EditPage',
        params: { siteId: page.siteId, pageId: page.id }
      }" class="page-card-name"
      @click.prevent
    >
      {{ page.name }}
    </router-link>
    <span v-if="page.isPinned" class="page-card-pin">
      <i class="el-icon-fa-map-pin" />
    </span>
    <small class="page-card-path">
      {{ page.path }}
    </small>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

$page-card-transition-speed: 0.1s;

.page-card {
  display: block;
  position: relative;
  background-color: $--color-white;
  border-top: solid 1px darken($--color-gray-10, 2.5%);
  padding: 1rem 1.25rem;
  user-select: none;
  transition: $page-card-transition-speed background-color;

  .page-card-pin {
    float: right;
    color: $--color-gray-80;
  }

  .page-card-name,
  .page-card-path {
    transition: $page-card-transition-speed color;
  }

  .page-card-path {
    display: block;
    color: $--color-gray-40;
    margin-top: 0.25rem;
  }

  &:first-child {
    border-top: none;
  }

  &:last-child {
    border-bottom: solid 1px darken($--color-gray-10, 2.5%);
  }

  &:focus {
    outline: none;
    background-color: lighten($--color-gray-10, 1%);
  }

  &.selected {
    background-color: $--color-primary-light-9;
    border-top-color: darken($--color-primary-light-9, 5%);
    color: $--color-primary;

    .page-card-pin,
    .page-card-name,
    .page-card-path {
      color: inherit;
    }
  }

  &.selected:last-child {
    border-bottom-color: darken($--color-primary-light-9, 5%);
  }

  &.selected:not(.page-cards-move) + .page-card {
    border-top-color: darken($--color-primary-light-9, 5%);
  }
}
</style>
